import clsx from 'clsx';
import { PropsWithChildren } from 'react';

import { useWidgetContext } from './Widget';
import { Loading } from './Loading';

interface Props {
  loading?: boolean;
  className?: string;
  contentClassName?: string;
}

export function WidgetBody({
  loading,
  className,
  children,
  contentClassName,
}: PropsWithChildren<Props>) {
  useWidgetContext();

  return (
    <div className={clsx(className, 'widget-body')}>
      {loading ? (
        <Loading />
      ) : (
        <div className={clsx('widget-content', contentClassName)}>
          {children}
        </div>
      )}
    </div>
  );
}
